import { useEffect, useRef, useState } from "react";
import dropin from "braintree-web-drop-in";
import { GetService } from "../../../Services/ConstantService";
import { API_URL } from "../../../Services/ApiService";
import { toastEmmit } from "../../../Helper/Toastr";

const BraintreeCheckout = ({ onSuccess }) => {
  const dropinInstance = useRef(null);
  const [initializing, setInitializing] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const initializeBraintree = async () => {
      try {
        const res = await GetService(API_URL.GET_BRAINTREE_PAYMENT_TOKEN);
        console.log(res);
        if (res?.data?.status && res?.data?.data?.clientToken) {
          const instance = await dropin.create({
            authorization: res?.data?.data?.clientToken,
            container: "#braintree-dropin",
            paypal: {
              flow: "vault",
            },
            //  paypalCredit: true,
          });

          dropinInstance.current = instance;
        } else {
          toastEmmit("error", "Failed to get client token.");
        }
      } catch (error) {
        toastEmmit("error", "Error initializing Braintree");
        console.error("Error initializing Braintree:", error);
      } finally {
        setInitializing(false);
      }
    };

    initializeBraintree();

    // Cleanup on unmount
    return () => {
      if (dropinInstance.current) {
        dropinInstance.current.teardown().catch(console.error);
      }
    };
  }, []);

  const handlePayment = async () => {
    if (!dropinInstance.current) return;

    setLoading(true);

    try {
      const { nonce } = await dropinInstance.current.requestPaymentMethod();
      onSuccess(nonce);
    } catch (error) {
      console.error("Payment Error:", error);
      toastEmmit("error", "Please complete the payment form correctly.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 pt-1">
      <div id="braintree-dropin" />
      <button
        disabled={initializing || loading}
        onClick={handlePayment}
        className="btn btn-primary text-white px-4 py-2 rounded mt-4"
        style={{
          background: "#1F4CE0",
        }}
      >
        {loading ? "Processing..." : "Pay Now"}
      </button>
    </div>
  );
};

export default BraintreeCheckout;
